<div>
  <div *ngFor="let configItem of value; let i = index">
    <ng-container *ngIf="editedIndex === i">
      <div class="form-area">
        <div class="config-input-area">
          <div class="control-area">
            <div class="label">
              Title:
            </div>
            <div class="input">
              <rappider-textbox [(ngModel)]="tempCrudFormItem.title" (blur)="onSave()"></rappider-textbox>
              <small *ngIf="tempValueSubmitted && !tempCrudFormItem.title"
                     class="error">*This field can't be empty</small>
            </div>
          </div>
          <div class="control-area">
            <div class="label">
              Field Name:
            </div>
            <div class="input">
              <rappider-textbox [(ngModel)]="tempCrudFormItem.fieldName" (blur)="onSave()"></rappider-textbox>
              <small *ngIf="!isFieldNameUnique() && tempValueSubmitted"
                     class="error">
                *Field Name must be unique.
              </small>
              <br>
              <small *ngIf="tempValueSubmitted && !tempCrudFormItem.fieldName"
                     class="error">*This field can't be empty</small>
            </div>
          </div>
          <!-- <div class="control-area">
            <div class="label">
              Type:
            </div>
            <div class="input">
              <rappider-select [ngModel]="tempCrudFormItem.type"
                               (ngModelChange)="onTypeChange($event)"
                               [options]="typeSelectOptions"
                               (blur)="onSave()"></rappider-select>
              <small *ngIf="tempValueSubmitted && !tempCrudFormItem.type"
                     class="error">*This field can't be empty</small>
            </div>
          </div> -->

          <ng-container *ngIf="tempCrudFormItem.type === CrudViewFormItemType.DatePicker">
            <div class="control-area">
              <div class="label">
                Date Format:
              </div>
              <div class="input">
                <rappider-select [(ngModel)]="tempCrudFormItem.dateFormat"
                                 [options]="dateFormatOptions"
                                 (blur)="onSave()"></rappider-select>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="tempCrudFormItem.type === CrudViewFormItemType.ImageUpload">
            <div class="control-area">
              <div class="label">
                Upload Button Visibility:
              </div>
              <div class="input">
                <rappider-checkbox [(ngModel)]="tempCrudFormItem.uploadButtonVisibility"
                                   (blur)="onSave()"></rappider-checkbox>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Width:
              </div>
              <div class="input">
                <rappider-dimension-select [(ngModel)]="imageUploadWidth"
                                           (ngModelChange)="onImageUploadWidthChange($event)"
                                           (blur)="onSave()"></rappider-dimension-select>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Height:
              </div>
              <div class="input">
                <rappider-dimension-select [(ngModel)]="imageUploadHeight"
                                           (ngModelChange)="onImageUploadHeightChange($event)"
                                           (blur)="onSave()"></rappider-dimension-select>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Image Upload Button Text:
              </div>
              <div class="input">
                <rappider-textbox [(ngModel)]="imageUploadButtonText"
                                  (ngModelChange)="onImageUploadButtonTextChange($event)"
                                  (blur)="onSave()"></rappider-textbox>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Image Upload Button Type:
              </div>
              <div class="input">
                <rappider-select [(ngModel)]="imageUploadButtonType"
                                 [options]="imageUploadButtonTypeOptions"
                                 (ngModelChange)="onImageUploadButtonTypeChange($event)"
                                 (blur)="onSave()"></rappider-select>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Image Upload Button Icon:
              </div>
              <div class="input">
                <rappider-icon-picker-wrapper [(ngModel)]="imageUploadButtonIcon"
                                              (ngModelChange)="onImageUploadButtonIconChange($event)"
                                              (blur)="onSave()"></rappider-icon-picker-wrapper>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="tempCrudFormItem.type === CrudViewFormItemType.RowForm">
            <div class="control-area">
              <div class="label">
                Columns:
              </div>
              <div class="input">
                <rappider-json-array [(ngModel)]="tempCrudFormItem.columns"
                                     [previewFieldNames]="tempCrudFormItem.columns"
                                     [modalTitle]="'Add Columns'"
                                     (blur)="onSave()"></rappider-json-array>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="tempCrudFormItem.type === CrudViewFormItemType.InputGroup">
            <div class="control-area">
              <div class="label">
                Textbox:
              </div>
              <div class="input">
                <rappider-json-input [(ngModel)]="tempCrudFormItem.textbox" (blur)="onSave()"></rappider-json-input>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Prefix Text:
              </div>
              <div class="input">
                <rappider-textbox [(ngModel)]="tempCrudFormItem.prefixText" (blur)="onSave()"></rappider-textbox>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Suffix Text:
              </div>
              <div class="input">
                <rappider-textbox [(ngModel)]="tempCrudFormItem.suffixText" (blur)="onSave()"></rappider-textbox>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Prefix Icon:
              </div>
              <div class="input">
                <rappider-json-input [(ngModel)]="tempCrudFormItem.prefixIcon" (blur)="onSave()"></rappider-json-input>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Suffix Icon:
              </div>
              <div class="input">
                <rappider-json-input [(ngModel)]="tempCrudFormItem.suffixIcon" (blur)="onSave()"></rappider-json-input>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Prefix Button:
              </div>
              <div class="input">
                <rappider-json-input [(ngModel)]="tempCrudFormItem.prefixButton" (blur)="onSave()"></rappider-json-input>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Suffix Button:
              </div>
              <div class="input">
                <rappider-json-input [(ngModel)]="tempCrudFormItem.suffixButton" (blur)="onSave()"></rappider-json-input>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="tempCrudFormItem.type === CrudViewFormItemType.Radio">
            <div class="control-area">
              <div class="label">
                Selectable Options:
              </div>
              <div class="input">
                <rappider-json-array [(ngModel)]="tempCrudFormItem.options" (blur)="onSave()"></rappider-json-array>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Color:
              </div>
              <div class="input">
                <rappider-color-picker [(ngModel)]="tempCrudFormItem.color" (blur)="onSave()"></rappider-color-picker>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Width:
              </div>
              <div class="input">
                <rappider-dimension-select [(ngModel)]="tempCrudFormItem.width" (blur)="onSave()"></rappider-dimension-select>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Height:
              </div>
              <div class="input">
                <rappider-dimension-select [(ngModel)]="tempCrudFormItem.height" (blur)="onSave()"></rappider-dimension-select>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="tempCrudFormItem.type === CrudViewFormItemType.RowSelect">
            <div class="control-area">
              <div class="label">
                Orderable:
              </div>
              <div class="input">
                <rappider-checkbox [(ngModel)]="tempCrudFormItem.orderable" (blur)="onSave()"></rappider-checkbox>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Columns:
              </div>
              <div class="input">
                <rappider-json-array [(ngModel)]="tempCrudFormItem.columns" (blur)="onSave()"></rappider-json-array>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Add Button Visible:
              </div>
              <div class="input">
                <rappider-checkbox [(ngModel)]="tempCrudFormItem.addButtonVisible" (blur)="onSave()"></rappider-checkbox>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Has Initial Empty Row:
              </div>
              <div class="input">
                <rappider-checkbox [(ngModel)]="tempCrudFormItem.hasInitialEmptyRow" (blur)="onSave()"></rappider-checkbox>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="tempCrudFormItem.type === CrudViewFormItemType.CheckboxList">
            <div class="control-area">
              <div class="label">
                Direction:
              </div>
              <div class="input">
                <rappider-select [(ngModel)]="tempCrudFormItem.direction"
                                 [options]="checkboxListDirectionOptions"
                                 (blur)="onSave()"></rappider-select>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Options:
              </div>
              <div class="input">
                <rappider-json-array [(ngModel)]="tempCrudFormItem.options" (blur)="onSave()"></rappider-json-array>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Select All Button Visibility:
              </div>
              <div class="input">
                <rappider-switch [(ngModel)]="tempCrudFormItem.isSelectAllButtonVisible" (blur)="onSave()"></rappider-switch>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="tempCrudFormItem.type === CrudViewFormItemType.CheckBox">
            <div class="control-area">
              <div class="label">
                Type:
              </div>
              <div class="input">
                <rappider-select [(ngModel)]="tempCrudFormItem.checkboxType"
                                 [options]="checkboxTypeOptions"
                                 (blur)="onSave()"></rappider-select>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Text:
              </div>
              <div class="input">
                <rappider-json-input [(ngModel)]="tempCrudFormItem.text" (blur)="onSave()"></rappider-json-input>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Tooltip:
              </div>
              <div class="input">
                <rappider-textbox [(ngModel)]="tempCrudFormItem.tooltip" (blur)="onSave()"></rappider-textbox>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="tempCrudFormItem.type === CrudViewFormItemType.Button">
            <div class="control-area">
              <div class="label">
                Text:
              </div>
              <div class="input">
                <rappider-textbox [(ngModel)]="tempCrudFormItem.text" (blur)="onSave()"></rappider-textbox>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Type:
              </div>
              <div class="input">
                <rappider-select [(ngModel)]="tempCrudFormItem.buttonType"
                                 [options]="buttonTypeOptions"
                                 (blur)="onSave()"></rappider-select>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="tempCrudFormItem.type === CrudViewFormItemType.Select">
            <div class="control-area">
              <div class="label">
                Size:
              </div>
              <div class="input">
                <rappider-select [(ngModel)]="tempCrudFormItem.size"
                                 [options]="inputSize"
                                 (blur)="onSave()"></rappider-select>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Select Mode:
              </div>
              <div class="input">
                <rappider-select [(ngModel)]="tempCrudFormItem.selectMode"
                                 [options]="selectMode"
                                 (blur)="onSave()"></rappider-select>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Options:
              </div>
              <div class="input">
                <rappider-row-form [(ngModel)]="tempCrudFormItem.options"
                                   [hasInitialEmptyRow]="true"
                                   addButtonText="Save Options"
                                   [addButtonVisible]="true"
                                   [columns]="rowFormColumnsConfig"
                                   (blur)="onSave()"></rappider-row-form>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="tempCrudFormItem.type === CrudViewFormItemType.TextBox">
            <div class="control-area">
              <div class="label">
                Size:
              </div>
              <div class="input">
                <rappider-select [(ngModel)]="tempCrudFormItem.size"
                                 [options]="inputSize"
                                 (blur)="onSave()"></rappider-select>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Textbox Type:
              </div>
              <div class="input">
                <rappider-select [(ngModel)]="tempCrudFormItem.textType"
                                 [options]="textboxTypeOptions"
                                 (blur)="onSave()"></rappider-select>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Mask Guide:
              </div>
              <div class="input">
                <rappider-switch [(ngModel)]="tempCrudFormItem.maskGuide" (blur)="onSave()"></rappider-switch>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Mention Supported:
              </div>
              <div class="input">
                <rappider-switch [(ngModel)]="tempCrudFormItem.mentionSupported" (blur)="onSave()"></rappider-switch>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Mention Prefix:
              </div>
              <div class="input">
                <rappider-textbox [(ngModel)]="tempCrudFormItem.mentionPrefix" (blur)="onSave()"></rappider-textbox>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Show Mask Typed:
              </div>
              <div class="input">
                <rappider-switch [(ngModel)]="tempCrudFormItem.showMaskTyped" (blur)="onSave()"></rappider-switch>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Drop Special Characters:
              </div>
              <div class="input">
                <rappider-switch [(ngModel)]="tempCrudFormItem.dropSpecialCharacters" (blur)="onSave()"></rappider-switch>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="tempCrudFormItem.type === CrudViewFormItemType.RadioGroup">
            <div class="control-area">
              <div class="label">
                Options:
              </div>
              <div class="input">
                <rappider-json-array [(ngModel)]="tempCrudFormItem.options" (blur)="onSave()"></rappider-json-array>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Invalid Config Text:
              </div>
              <div class="input">
                <rappider-textbox [(ngModel)]="tempCrudFormItem.invalidConfigText" (blur)="onSave()"></rappider-textbox>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Size:
              </div>
              <div class="input">
                <rappider-select [(ngModel)]="tempCrudFormItem.size"
                                 [options]="inputSize"
                                 (blur)="onSave()"></rappider-select>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Disabled:
              </div>
              <div class="input">
                <rappider-switch [(ngModel)]="tempCrudFormItem.disabled" (blur)="onSave()"></rappider-switch>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Direction:
              </div>
              <div class="input">
                <rappider-select [(ngModel)]="tempCrudFormItem.direction"
                                 [options]="radioGroupDirectionOptions"
                                 (blur)="onSave()"></rappider-select>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Gap:
              </div>
              <div class="input">
                <rappider-textbox [(ngModel)]="tempCrudFormItem.gap" (blur)="onSave()"></rappider-textbox>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="tempCrudFormItem.type === CrudViewFormItemType.Slider">
            <div class="control-area">
              <div class="label">
                Read Only:
              </div>
              <div class="input">
                <rappider-switch [(ngModel)]="tempCrudFormItem.readonly" (blur)="onSave()"></rappider-switch>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Dual Mode:
              </div>
              <div class="input">
                <rappider-switch [(ngModel)]="tempCrudFormItem.dualMode" (blur)="onSave()"></rappider-switch>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Min Range:
              </div>
              <div class="input">
                <rappider-number-input [(ngModel)]="tempCrudFormItem.minRange" (blur)="onSave()"></rappider-number-input>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Max Range:
              </div>
              <div class="input">
                <rappider-number-input [(ngModel)]="tempCrudFormItem.maxRange" (blur)="onSave()"></rappider-number-input>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Custom Max:
              </div>
              <div class="input">
                <rappider-switch [(ngModel)]="tempCrudFormItem.customMax" (blur)="onSave()"></rappider-switch>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Step:
              </div>
              <div class="input">
                <rappider-number-input [(ngModel)]="tempCrudFormItem.step" (blur)="onSave()"></rappider-number-input>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Marks:
              </div>
              <div class="input">
                <rappider-json-input [(ngModel)]="tempCrudFormItem.marks" (blur)="onSave()"></rappider-json-input>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="tempCrudFormItem.type === CrudViewFormItemType.InlineRowForm">
            <div class="control-area">
              <div class="label">
                Orderable:
              </div>
              <div class="input">
                <rappider-switch [(ngModel)]="tempCrudFormItem.orderable" (blur)="onSave()"></rappider-switch>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Columns:
              </div>
              <div class="input">
                <rappider-json-array [(ngModel)]="tempCrudFormItem.columns" (blur)="onSave()"></rappider-json-array>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Order Numbers Visibility:
              </div>
              <div class="input">
                <rappider-switch [(ngModel)]="tempCrudFormItem.orderNumbersVisibility" (blur)="onSave()"></rappider-switch>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Single Row:
              </div>
              <div class="input">
                <rappider-switch [(ngModel)]="tempCrudFormItem.singleRow" (blur)="onSave()"></rappider-switch>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="tempCrudFormItem.type === CrudViewFormItemType.CheckboxTable">
            <div class="control-area">
              <div class="label">
                Checkbox Mode:
              </div>
              <div class="input">
                <rappider-switch [(ngModel)]="tempCrudFormItem.checkboxMode" (blur)="onSave()"></rappider-switch>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Rows:
              </div>
              <div class="input">
                <rappider-row-form [(ngModel)]="tempCrudFormItem.rows"
                                   [hasInitialEmptyRow]="true"
                                   addButtonText="Save Options"
                                   [addButtonVisible]="true"
                                   [columns]="rowFormColumnsConfig"
                                   (blur)="onSave()"></rappider-row-form>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Columns:
              </div>
              <div class="input">
                <rappider-row-form [(ngModel)]="tempCrudFormItem.columns"
                                   [hasInitialEmptyRow]="true"
                                   addButtonText="Save Options"
                                   [addButtonVisible]="true"
                                   [columns]="rowFormColumnsConfig"
                                   (blur)="onSave()"></rappider-row-form>
              </div>
            </div>
            <div class="control-area">
              <div class="label">
                Check:
              </div>
              <div class="input">
                <rappider-row-form [(ngModel)]="tempCrudFormItem.check"
                                   [hasInitialEmptyRow]="true"
                                   addButtonText="Save Options"
                                   [addButtonVisible]="true"
                                   [columns]="checkboxTableCheckConfig"
                                   (blur)="onSave()"></rappider-row-form>
              </div>
            </div>

            <div class="control-area">
              <div class="label">
                Row Title Placement:
              </div>
              <div class="input">
                <rappider-select [(ngModel)]="tempCrudFormItem.rowTitlePlacement"
                                 [options]="rowTitlePlacement"
                                 (blur)="onSave()"></rappider-select>
              </div>
            </div>

            <div class="control-area">
              <div class="label">
                Column Title Placement:
              </div>
              <div class="input">
                <rappider-select [(ngModel)]="tempCrudFormItem.columnTitlePlacement"
                                 [options]="columnTitlePlacement"
                                 (blur)="onSave()"></rappider-select>
              </div>
            </div>

            <div class="control-area">
              <div class="label">
                Item Placement:
              </div>
              <div class="input">
                <rappider-select [(ngModel)]="tempCrudFormItem.itemPlacement"
                                 [options]="itemPlacement"
                                 (blur)="onSave()"></rappider-select>
              </div>
            </div>
          </ng-container>

          <div class="control-area">
            <div class="label">
              Placeholder:
            </div>
            <div class="input">
              <rappider-textbox [(ngModel)]="tempCrudFormItem.placeholder" (blur)="onSave()"></rappider-textbox>
            </div>
          </div>
          <div class="control-area">
            <div class="label">
              Description:
            </div>
            <div class="input">
              <rappider-textbox [(ngModel)]="tempCrudFormItem.description" (blur)="onSave()"></rappider-textbox>
            </div>
          </div>
          <div class="control-area">
            <div class="label">
              Mask:
            </div>
            <div class="input">
              <rappider-textbox [(ngModel)]="tempCrudFormItem.mask" (blur)="onSave()"></rappider-textbox>
            </div>
          </div>
          <div class="control-area">
            <div class="label">
              Hint:
            </div>
            <div class="input">
              <rappider-textbox [(ngModel)]="tempCrudFormItem.hint" (blur)="onSave()"></rappider-textbox>
            </div>
          </div>
          <div class="control-area">
            <div class="label">
              Label Icon:
            </div>
            <div class="input">
              <rappider-icon-picker-wrapper [(ngModel)]="tempCrudFormItem.labelIcon" (blur)="onSave()"></rappider-icon-picker-wrapper>
            </div>
          </div>
          <!-- <div class="control-area">
            <div class="label">
              Index:
            </div>
            <div class="input">
              <rappider-textbox [(ngModel)]="tempCrudFormItem.index"></rappider-textbox>
            </div>
          </div> -->
          <div class="control-area">
            <div class="label">
              Validators:
            </div>
            <div class="input">
              <rappider-validators-pattern-tab-list-wrapper [ngModel]="getTransformValidators(tempCrudFormItem.validators)" (ngModelChange)="onValidatorsChange($event)"></rappider-validators-pattern-tab-list-wrapper>
            </div>
          </div>
          <div class="control-area">
            <div class="label">
              Css Class:
            </div>
            <div class="input">
              <rappider-textbox [(ngModel)]="tempCrudFormItem.cssClass" (blur)="onSave()"></rappider-textbox>
            </div>
          </div>
          <div class="control-area">
            <div class="label">
              Css Style:
            </div>
            <div class="input">
              <rappider-json-array [(ngModel)]="tempCrudFormItem.cssStyle"
                                   [previewFieldNames]="tempCrudFormItem.cssStyle"
                                   (blur)="onSave()"></rappider-json-array>
            </div>
          </div>
          <div class="control-area">
            <div class="label">
              Visible:
            </div>
            <div class="input">
              <rappider-switch [(ngModel)]="tempCrudFormItem.visible" (blur)="onSave()"></rappider-switch>
            </div>
          </div>
          <div class="control-area">
            <div class="label">
              Loading:
            </div>
            <div class="input">
              <rappider-switch [(ngModel)]="tempCrudFormItem.loading" (blur)="onSave()"></rappider-switch>
            </div>
          </div>
          <div class="control-area">
            <div class="label">
              Metadata:
            </div>
            <div class="input">
              <rappider-row-form [(ngModel)]="tempCrudFormItem.metadata" (blur)="onSave()"></rappider-row-form>
            </div>
          </div>
          <div class="control-area">
            <div class="label">
              Default:
            </div>
            <div class="input">
              <rappider-textbox [(ngModel)]="tempCrudFormItem.default" (blur)="onSave()"></rappider-textbox>
            </div>
          </div>
          <div class="control-area">
            <div class="label">
              Is Linked:
            </div>
            <div class="input">
              <rappider-switch [(ngModel)]="tempCrudFormItem.isLinked" (blur)="onSave()"></rappider-switch>
            </div>
          </div>
          <div class="control-area">
            <div class="label">
              Linked Field Name:
            </div>
            <div class="input">
              <rappider-textbox [(ngModel)]="tempCrudFormItem.linkedFieldName" (blur)="onSave()"></rappider-textbox>
            </div>
          </div>
          <div class="control-area">
            <div class="label">
              Link Data Transformation Function:
            </div>
            <div class="input">
              <rappider-code-editor
                                    [(ngModel)]="tempCrudFormItem.linkDataTransformationFunction" (blur)="onSave()"></rappider-code-editor>
            </div>
          </div>
          <div class="control-area">
            <div class="label">
              Settings:
            </div>
            <div class="input">
              <rappider-code-editor [(ngModel)]="tempCrudFormItem.settings" (blur)="onSave()"></rappider-code-editor>
            </div>
          </div>

          <div class="control-area">
            <div class="label">
              Section:
            </div>
            <div class="input">
              <rappider-textbox [(ngModel)]="tempCrudFormItem.section" (blur)="onSave()"></rappider-textbox>
            </div>
          </div>

          <div class="control-area">
            <div class="label">
              Column Width: (%)
            </div>
            <div class="input">
                 <rappider-number-input [(ngModel)]="tempCrudFormItem.columnWidth" (blur)="onSave()"></rappider-number-input>
                 <rappider-icon [name]="'fa-regular fa-circle-info'" [color]="'var(--primary-color)'"></rappider-icon> Vertical layout is recommended for optimal use of this column width feature.
            </div>
          </div>
          <div class="control-area">
            <div class="label">
              Show Required Sign:
            </div>
            <div class="input">
              <rappider-switch [(ngModel)]="tempCrudFormItem.showRequiredSign" (blur)="onSave()"></rappider-switch>
            </div>
          </div>
          <div class="control-area">
            <div class="label">
              Show Colon Sign:
            </div>
            <div class="input">
              <rappider-switch [(ngModel)]="tempCrudFormItem.showColonSign" (blur)="onSave()"></rappider-switch>
            </div>
          </div>
        </div>
        <!-- <div class="button-area">
          <div class="save-button">
            <rappider-button text="Save"
                             type="primary"
                             (click)="onSave()"></rappider-button>
          </div>
           &nbsp;
          <div class="cancel-button">
            <rappider-button *ngIf="!isFirstInitialize"
                             text="Close"
                             (click)="onEditCancel()"></rappider-button>
          </div>
        </div> -->
      </div>
    </ng-container>
  </div>
</div>
<ng-container *ngIf="!selectedItem">
  <rappider-alert [type]="FormBuilderEmptyInfoAlertConfig.type"
                  [description]="FormBuilderEmptyInfoAlertConfig.description"
                  [closeable]="FormBuilderEmptyInfoAlertConfig.closeable"
                  [showIcon]="FormBuilderEmptyInfoAlertConfig.showIcon"></rappider-alert>
</ng-container>

<small *ngIf="hasAddError"
       class="error">You're already adding an item. Please save before adding a new one.</small>
<!-- <rappider-button text="Add Form Element"
                 (click)="addFormControl()"></rappider-button> -->
